import SeoArticlePage from '@/pages/article/SeoArticlePage';
import { couponArticle } from '@/mocks/articles';

export default function CouponPage() {
  return <SeoArticlePage article={couponArticle} />;
}